import { render } from "./DirectMailHome.vue?vue&type=template&id=4288a26c"
import script from "./DirectMailHome.vue?vue&type=script&lang=js"
export * from "./DirectMailHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/direct_mail/DirectMailHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4288a26c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4288a26c', __exports__)) {
    api.reload('4288a26c', __exports__)
  }
  
  module.hot.accept("./DirectMailHome.vue?vue&type=template&id=4288a26c", () => {
    api.rerender('4288a26c', render)
  })

}


export default __exports__